import { Outlet, Link } from "react-router-dom";
import {
  AppBar,
  Box,
  Container,
  Stack,
  Typography,
  useScrollTrigger,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import { Footer } from "./Footer";
import { useLocation } from "react-router-dom";

const Layout = () => {
  const scrolled = useScrollTrigger({
    disableHysteresis: true,
    threshold: 50,
  });
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const location = useLocation();

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <AppBar
        position="fixed"
        elevation={scrolled ? 2 : 0}
        sx={{
          background: scrolled
            ? isDark
              ? "rgba(30, 30, 30, 0.8)"
              : "rgba(255, 255, 255, 0.8)"
            : "transparent",
          backdropFilter: "blur(10px)",
          transition: "all 0.3s ease-in-out",
          "& a": {
            color: scrolled && isDark ? "secondary.main" : "primary.main",
          },
        }}
      >
        <Container>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            py={2}
          >
            <Stack direction="row" spacing={{ xs: 2, sm: 4 }}>
              {["Home", "Work", "Blog"].map((item) => {
                const path = item === "Home" ? "/" : `/${item.toLowerCase()}`;
                const isActive =
                  item === "Home"
                    ? location.pathname === "/"
                    : location.pathname.startsWith(path);

                return (
                  <Typography
                    key={item}
                    component={Link}
                    to={path}
                    sx={{
                      color: "primary.main",
                      textDecoration: "none",
                      position: "relative",
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        width: isActive ? "100%" : "0%",
                        height: "2px",
                        bottom: -4,
                        left: 0,
                        backgroundColor: "secondary.main",
                        transition: "width 0.3s ease-in-out",
                      },
                      "&:hover::after": {
                        width: "100%",
                      },
                    }}
                  >
                    {item}
                  </Typography>
                );
              })}
            </Stack>
          </Stack>
        </Container>
      </AppBar>

      <Box
        component={motion.main}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.5 }}
      >
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
